import React from 'react'
import { TimeTravelProvider } from '@fs/zion-rootstech'
import { CountryProvider } from './CountryProvider'
import { QAPermissionsProvider } from './PermissionsProvider'
import { QASponsorLevelProvider } from './SponsorLevelProvider'

const QualityAssuranceProviders = ({ children }) => {
  return (
    <TimeTravelProvider>
      <CountryProvider>
        <QAPermissionsProvider>
          <QASponsorLevelProvider>{children}</QASponsorLevelProvider>
        </QAPermissionsProvider>
      </CountryProvider>
    </TimeTravelProvider>
  )
}

export default QualityAssuranceProviders
